import { getToken } from "../utils";
import { BASE_URL } from "../endpoints";

const getDashboardData = async (taxYear: number) => {
  const token = getToken();
  if (token) {
    try {
      const response = await fetch(`${BASE_URL}/api/home?tax_year=${taxYear}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status === 200) {
        const data = await response.json();
        return data;
      } else {
        return null;
      }
    } catch {
      return null; // network error
    }
  } else {
    return null; // No token
  }
};

export default getDashboardData;
